import HotelCardThumbnailSkeleton from './hotel-card-thumbnail-skeleton.svg';
import SmilesBed from './smiles-bed.svg';
import SmilesClubCoin from './smiles-club-coin-big.svg';
import SmilesClubSignedLogo from './smiles-club-signed-card-logo.svg';
import SmilesTravelCaseError from './smiles-travel-case-error.svg';
import SmilesTravelCase from './smiles-travel-case.svg';
import { ReactComponent as ThumbSkeleton } from './thumb-skeleton.svg';

export default {
  'smiles-bed': SmilesBed,
  'smiles-travel-case-error': SmilesTravelCaseError,
  'smiles-travel-case': SmilesTravelCase,
  'thumb-skeleton': ThumbSkeleton,
  'hotel-card-thumbnail-skeleton': HotelCardThumbnailSkeleton,
  'smiles-club-signed-logo': SmilesClubSignedLogo,
  'smiles-club-coin': SmilesClubCoin,
};
